<template>
  <section class="hero is-primary">
    <div class="hero-body">
      <div class="container is-max-hd">
        <div class="columns">
          <div class="column">
            <p class="title is-3">{{ patient.first_name }} {{ patient.last_name }}</p>
            <p class="subtitle">
              <template v-if="showSubscriberName">
                <strong>Subscriber Name:</strong>
                <span>{{ subscriber.first_name }} {{ subscriber.last_name }}</span>
                <br />
              </template>

              <strong>{{ personType }}</strong>
              <span v-if="patient.gender">&nbsp;- {{ patient.gender }}</span>
              <span v-if="patient.dob">&nbsp;- {{ patient.dob | formatDate }}</span>
              <br />
              <span v-if="displayPayerName">
                <strong>Payer</strong>
                :
                {{ displayPayerName }}
              </span>
              <br v-if="displayPayerName" />
              <span v-if="subscriber.member_id">
                <strong>MemberID</strong>
                :
                {{ subscriber.member_id }}
              </span>
              <br />
              <span v-if="subscriber.id_card_number">
                <strong>ID Card Number</strong>
                :
                {{ subscriber.id_card_number }}
              </span>
              <br v-if="subscriber.id_card_number" />
              <span>
                <strong>Facility</strong>
                :
                {{ provider }}
              </span>
              <br />
              <span>
                <strong>Created</strong>
                :
                {{ createdAt | formatDate }}
              </span>
              <br />
              <span>
                <strong>As of</strong>
                :
                {{ asOfDate | formatDate }}
              </span>
              <br />
              <span v-if="referenceNumber">
                <strong>Ref</strong>
                :{{ referenceNumber }}
                <br />
              </span>
            </p>
          </div>

          <div class="column has-text-left">
            <p class="subtitle" v-if="showPatientAddress">
              <strong>Patient Address:</strong>
              {{ patient.address.street }}
              <br />
              {{ patient.address.city }}, {{ patient.address.state }},
              {{ patient.address.zip }}
            </p>

            <p class="subtitle" v-if="showSubscriberAddress">
              <strong>Subscriber Address:</strong>
              {{ subscriber.address.street }}
              <br />
              {{ subscriber.address.city }}, {{ subscriber.address.state }},
              {{ subscriber.address.zip }}
            </p>

            <p class="subtitle" v-if="primaryCareProvider && primaryCareProvider.firstName">
              <strong>Primary Care Provider:</strong>
              <br />
              {{ primaryCareProvider.firstName }} {{ primaryCareProvider.lastName }}
              <br />
              <template v-if="primaryCareProvider.address">
                {{ primaryCareProvider.address.street }}
                <br />
                {{ primaryCareProvider.address.city }}, {{ primaryCareProvider.address.state }},
                {{ primaryCareProvider.address.zip }}
              </template>
              <template v-if="primaryCareProvider.npi">
                <br />
                NPI: {{ primaryCareProvider.npi }}
              </template>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InquiryDetailHeader',
  props: {
    createdAt: String,
    asOfDate: String,
    provider: String,
    patient: Object,
    subscriber: Object,
    payer: Object,
    payerNameOverride: String,
    primaryCareProvider: Object,
    referenceNumber: String,
    isPdf: { type: Boolean, default: false },
  },
  computed: {
    showSubscriberName() {
      return this.patient.relationship !== 'Self';
    },
    showPatientAddress() {
      return Object.hasOwn(this.patient, 'address');
    },
    showSubscriberAddress() {
      return ['street', 'city', 'state', 'zip'].some((field) =>
        String(this.subscriber?.address?.[field] ?? '').trim()
      );
    },
    personType() {
      if (this.patient.relationship === 'Self') {
        return 'Subscriber';
      }
      return this.patient.relationship;
    },
    displayPayerName() {
      if (this.payerNameOverride != null && this.payerNameOverride !== '') {
        return this.payerNameOverride;
      }
      return this.payer?.name || '';
    },
  },
};
</script>

<style scoped>
.hero-body { padding: 1.75rem 1.5rem; }
.subtitle { font-size: 1rem; line-height: 1.7; overflow-wrap: anywhere; }
.title { margin-bottom: 1.75rem; }
@media (max-width: 768px) { .hero-body { padding: 1.5rem 1rem; } }
</style>
